import React from 'react';
import classNames from 'classnames';

const CheckBox = ({checked, text, onChecked, disabled = false, type = 'normal', innerStyle = 'red', textMode='div' }) => {
  if (type === 'normal') {
    let _text = null;
    if(text) {
      switch(textMode) {
        case "div":
          _text = (!disabled && !checked)
            ? <div className="ui-svg-checkbox__text color-light">{text}</div>
            : <div className="ui-svg-checkbox__text">{text}</div>;
        break;
        case "h1":
          _text = <h1>{text}</h1>;
          break;
      }
    }
    return (
    <div className={classNames('ui-svg-checkbox', {'ui-svg-checkbox--disabled': disabled})}
         onClick={() => !disabled && onChecked(checked)}>
      <div className="ui-svg-checkbox__icon">
        <svg className="ui-svg-checkbox__icon-circle" height="30" width="30">
          <circle cx="15" cy="15" r="12.5" stroke="#979797" strokeWidth="3" fill="#ffffff"/>
          {disabled? <circle cx="15" cy="15" r="6" stroke="#c6c6c6" strokeWidth="3" fill="#c6c6c6"/> : null}
        </svg>

        {checked && !disabled ? <div className="ui-svg-checkbox__icon-checked-icon"/> : null}

        {!disabled && !checked ?
          <svg className="employees-checkbox-circle" height="30" width="30">
            { innerStyle === 'red' ?
              <circle cx="15" cy="15" r="12.5" stroke="#979797" strokeWidth="3" fill="#ff0000"/>
            : null }
            <circle cx="15" cy="15" r="7" fill="white"/>
          </svg> : null}

      </div>
      {_text}

    </div>
    );
  } else if (type === 'small') {
    return (
      <div className="ui-svg-checkbox ui-svg-checkbox--small"
           onClick={() => !disabled && onChecked(checked)}>
        <div className="ui-svg-checkbox__icon">
          <svg className="ui-svg-checkbox__icon-circle" height="30" width="30">
            <circle cx="15" cy="15" r="10" stroke="#979797" strokeWidth="3" fill="#ffffff"/>
            {!checked && !disabled ? <circle cx="15" cy="15" r="5" fill="#ff0000"/> : null}
            {disabled ? <circle cx="15" cy="15" r="5" fill="#c6c6c6"/> : null}
          </svg>

          {checked && !disabled ? <div className="ui-svg-checkbox__icon-checked-icon"/> : null}

        </div>

        <div className="ui-svg-checkbox__text">{text}</div>
      </div>
    )
  }
};


const formCheckBox = () => {
  return (
    null
  )
};


export default CheckBox;
export {
  CheckBox,
  formCheckBox
};


// WEBPACK FOOTER //
// ./node_modules/shared_components/components/CheckBox.js